/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { SearchNotificationsMutationRequest, SearchNotificationsMutationResponse } from '../types/SearchNotifications.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getSearchNotificationsUrl() {
  const res = { method: 'POST', url: `/notifications/search` as const };
  return res;
}

/**
 * @summary Search notifications
 * {@link /notifications/search}
 */
export async function searchNotifications(
  data: SearchNotificationsMutationRequest,
  config: Partial<RequestConfig<SearchNotificationsMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<SearchNotificationsMutationResponse, ResponseErrorConfig<Error>, SearchNotificationsMutationRequest>({
    method: 'POST',
    url: getSearchNotificationsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
